export const hrefToScheme = (href) => {
  const colonIndex = href.indexOf(":")
  if (colonIndex === -1) return ""
  return href.slice(0, colonIndex)
}
